import { useLocation } from "react-router-dom";
import InquiryForm from "@/components/site/InquiryForm";
import ContactPanel from "@/components/site/ContactPanel";
import FAQSection from "@/components/site/FAQSection";
import SEO, { breadcrumbsLd, faqLd } from "@/components/site/SEO";
import { FAQS } from "@/lib/site";

const useQueryType = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  return params.get("type") || "";
};

const ContactPage = () => {
  const officeType = useQueryType();

  return (
    <>
      <SEO
        title="Contact Leasing · Schedule a Tour"
        description="Schedule an office tour at Weston Commercial Center. Call 954-384-6949 or send an inquiry — we respond within one business hour with available suites that match."
        path="/contact"
        jsonLd={[
          breadcrumbsLd([
            { name: "Home", path: "/" },
            { name: "Contact", path: "/contact" },
          ]),
          faqLd(FAQS),
        ]}
      />
      <section className="bg-[var(--bg)] border-b border-[var(--border)]">
        <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-20 py-20 md:py-28">
          <div className="eyebrow">Contact leasing</div>
          <h1 className="hero-display text-[52px] md:text-[96px] mt-5 leading-[1.0] max-w-4xl">
            Tell us what you <em className="italic text-[var(--primary)]">need.</em>
          </h1>
          <p className="mt-7 max-w-2xl text-[16px] leading-relaxed text-[var(--text-muted)]">
            Whether you&apos;re hunting for a single private office or a full
            executive suite, send the details below and we&apos;ll come back within
            one business hour with availability, pricing and a recommended
            tour time.
          </p>
        </div>
      </section>

      <section className="bg-[var(--bg)] border-b border-[var(--border)]">
        <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-20 py-12 md:py-20">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
            <div className="lg:col-span-7">
              <InquiryForm
                defaultOfficeType={officeType}
                sourcePage="contact"
                heading="Schedule a tour or request availability"
                subheading="One form, one response. We'll suggest two or three suites that fit and book a 30-minute walk-through."
              />
            </div>
            <div className="lg:col-span-5">
              <ContactPanel />
            </div>
          </div>
        </div>
      </section>

      <FAQSection />
    </>
  );
};

export default ContactPage;
